__turbopack_context__.v({
  "accordion": "GQ4XwG_accordion",
  "accordion__label": "GQ4XwG_accordion__label",
  "accordion__plus-minus": "GQ4XwG_accordion__plus-minus",
  "accordion__trigger": "GQ4XwG_accordion__trigger",
  "accordion__trigger--spaced-out": "GQ4XwG_accordion__trigger--spaced-out",
  "accordion__trigger-icon": "GQ4XwG_accordion__trigger-icon",
  "accordion__trigger-icon--is-open": "GQ4XwG_accordion__trigger-icon--is-open",
  "toggle-icon": "GQ4XwG_toggle-icon",
});
